import { FC, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './stylesPhone.css';

interface InternationalPhonesHookFormProps {
  label?: string;
  name: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  onBlur?: () => void;
  error?: string;
  touched?: boolean;
  defaultCountry?: string;
}

const InternationalPhonesHookForm: FC<InternationalPhonesHookFormProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  defaultCountry = 'AR',
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  useEffect(() => {
    setHasValue(!!value);
  }, [value]);

  const handlePhoneChange = (phoneValue: string | undefined) => {
    onChange?.(phoneValue);
    setHasValue(!!phoneValue);
  };

  const handleBlur = () => {
    setIsFocused(false);
    onBlur?.();
  };

  const hasError = touched && error;

  return (
    <div className="phone-input-container">
      <div
        className={`phone-input-wrapper ${isFocused ? 'focused' : ''} ${
          hasError ? 'error' : ''
        } ${hasValue ? 'has-value' : ''}`}
      >
        {label && (
          <label className={`phone-input-label ${hasError ? 'floating-error': (isFocused) ? 'floating' : 'floating-done'}`}>
            {(touched || hasError || hasValue || isFocused) && label}
          </label>
        )}
        <PhoneInput
          international
          defaultCountry={defaultCountry as any}
          value={value}
          onChange={handlePhoneChange}
          onFocus={() => setIsFocused(true)}
          onBlur={handleBlur}
          className="phone-input-element"
        />
      </div>
      {hasError && error && (
        <div className="phone-input-error">{error}</div>
      )}
    </div>
  );
};

export default InternationalPhonesHookForm;
